{
  "data_driven": {
    "formula_applied": "Fórmula aplicada",
    "by_attributes": "Por atributos",
    "any_others": "Cualquier otro"
  },
  "styles2": {
    "bold": "Atrevido",
    "regular": "Normal",
    "on": "En",
    "off": "Apagado",
    "arrow_spacing": "Espaciado entre flechas",
    "arrow_colour": "Color de la flecha",
    "arrow_size": "Tamaño de flecha",
    "arrow_opacity": "Opacidad de la flecha",
    "rotation": "Rotación",
    "rotate_icon": "Icono de rotación",
    "orientation_3d": "Orientación 3D",
    "flat": "Plano",
    "raised": "Levantado",
    "degrees": "Grados",
    "model": "Modelo",
    "type": "Tipo",
    "scale": "Escala",
    "choose_model": "Elija el modelo",
    "error_loading_models": "Se ha producido un error al cargar los modelos 3D",
    "solid": "Sólido",
    "dashed": "Discontinuo",
    "type_of_line": "Tipo de línea",
    "Line": "Línea",
    "Area": "Área",
    "Point": "Punto",
    "Icon": "Icono",
    "Model": "Modelo",
    "LineModel": "Línea de modelos 3D",
    "AreaModel": "Área de modelos 3D",
    "spacing": "Espaciado",
    "plural": {
      "Icon": "Iconos",
      "Point": "Puntos"
    }
  },
  "object": {
    "deleteTitle": "Eliminar objeto (s) seleccionado (s)",
    "deleteDescription": "¿Está seguro de que desea eliminar los objetos seleccionados?",
    "deleteToast": "{{ count }} objetos eliminados",
    "multiple": "Múltiples",
    "multiple_objects": "Múltiples objetos"
  },
  "controls": {
    "draw": "Dibuja",
    "copy": "Copiar",
    "select": "Seleccionar (capas activas)",
    "area_select": "Seleccione (Todas las capas)",
    "area_select_invalid": "El área dibujada debe tener 3 o más puntos para ser válida",
    "analysis": "Análisis",
    "search": "Búsqueda",
    "grab": "Agarra",
    "toggle_3d_terrain": "Terreno 3D",
    "toggle_globe": "Vista de globo",
    "toggle_3d_buildings": "Edificios 3D",
    "zoom_in": "Amplíe",
    "zoom_out": "Alejar",
    "reset": "Restablecer la vista",
    "vr": "Gemelo digital",
    "comments": "Comentarios",
    "calendar": "Calendario",
    "zoom_to_all_objects": "Amplíe todos los objetos",
    "no_objects_to_zoom": "No hay objetos visibles en el plano",
    "bookmarks": "Marcadores"
  },
  "analysis": {
    "analysis_title": "Herramientas de análisis",
    "distance_title": "Distancia",
    "distance_description": "Mida la distancia a lo largo de una línea",
    "distance_content": {
      "title": "Distancia total de la línea de referencia en el mapa"
    },
    "walk_time_title": "Tiempo de caminata",
    "walk_time_description": "Calcula el tiempo de caminata a lo largo de una línea",
    "walk_time_content": {
      "title": "Tiempo total de viaje al caminar",
      "approx_time": "Aprox. {{ speed }} minutos a",
      "m_per_second": "m/segundo"
    },
    "flow_rate_title": "velocidad de flujo",
    "flow_rate_description": "Flujo calculado de personas a través de una puerta (línea dibujada en el mapa)",
    "flow_rate_content": {
      "total_width": "Ancho total de la puerta (longitud de la línea)",
      "per_minute_per_hour": "{{ perMinute }} por {{ perHour }} por hora",
      "at": "a",
      "people_meter_minute": "personas/metro/ minuto",
      "fruin_service_levels": "Niveles de servicio de Fruin"
    },
    "area_title": "Área",
    "area_description": "Mida el área dentro de una forma en el mapa",
    "area_content": {
      "title": "Área total del polígono de referencia en el mapa"
    },
    "capacity_content": {
      "total_area": "Área total",
      "per_m_sq": "{{ perMSq }} por m²",
      "at": "a",
      "people_meter_sq": "m²/persona",
      "people_ft_sq": "pies²/persona",
      "fruin_service_levels": "Niveles de servicio de Fruin"
    },
    "capacity_title": "Capacidad",
    "capacity_description": "Calcula la capacidad de retención (personas) de un área en el mapa",
    "count_title": "Cuenta",
    "count_description": "Cuenta los objetos dentro de un área del mapa",
    "count_content": {
      "total": "Total",
      "current_level": "Nivel actual",
      "all_levels": "Todos los niveles"
    }
  },
  "styles": {
    "line_fill": "Relleno de línea",
    "colour": "Color",
    "colours": "Colores",
    "opacity": "Opacidad",
    "blur": "Difuminar",
    "measurement": "Medición",
    "width": "Anchura",
    "offset": "Offset",
    "join_and_end": "Extremos y uniones",
    "join": "Se une",
    "end": "Termina",
    "arrows": "Flechas",
    "line_terminator_icon": "Icono (s) de final de línea",
    "line_terminator_icon_start": "Comenzar",
    "line_terminator_icon_end": "Finalizar",
    "line_terminator_icon_both": "Ambos",
    "text": "Texto",
    "text_colour": "Color del texto",
    "text_font": "Tipo de letra del texto",
    "text_weight": "Peso del texto",
    "text_size": "Tamaño del texto",
    "text_overlap": "Superposición de texto",
    "allow_text_overlap": "Mostrar todo",
    "no_text_overlap": "Combinar",
    "text_outline_width": "Ancho del contorno del texto",
    "text_outline_colour": "Color del contorno del texto",
    "text_opacity": "Opacidad del texto",
    "text_content": "Contenido del texto",
    "outline": "Esquema",
    "outline_type": "Tipo de esquema",
    "outline_colour": "Color del contorno",
    "outline_opacity": "Opacidad del contorno",
    "outline_width": "Anchura del contorno",
    "outline_blur": "Borrón del contorno",
    "no_colour": "Sin color",
    "company_palette": "Paleta de la empresa",
    "type_of_area": "Tipo de área",
    "area_2d": "Área 2D",
    "area_3d": "Área 3D",
    "height": "Altura",
    "type_of_point": "Tipo de punto",
    "point_fill": "Relleno de puntos",
    "radius": "Radio",
    "pitch_alignment": "Orientación 3D",
    "area_fill": "Relleno de área",
    "placement": "Colocación",
    "pitch_alignment_map": "Plano",
    "pitch_alignment_viewport": "Levantado",
    "pitch_alignment_map_desc": "{{ styleType }} se encuentran planos en el plano del mapa",
    "pitch_alignment_viewport_desc": "{{ styleType }} siempre estará orientado hacia la cámara",
    "icon": "Icono",
    "icon_image": "Imagen de icono",
    "icon_size": "Tamaño",
    "icon_colour": "Color",
    "icon_opacity": "Opacidad",
    "rotation": "Rotación",
    "allow_overlap": "Superposición de iconos",
    "show_all": "Mostrar todo",
    "combine": "Combinar",
    "choose_icon_image": "Elige la imagen del icono",
    "open_icon_selector": "Abrir selector de iconos",
    "spacing": "Espaciado",
    "model_offset": "Offset de modelo",
    "line_model_line_colour": "Color de línea",
    "line_model_line_width": "Ancho de línea",
    "type": "Tipo de línea",
    "line_model_line_type": "Tipo de línea"
  }
}